import React, { Component } from 'react'
import AudioSpectrum from './AudioSpectrum'
import { AudioAnalyserProps, AudioAnalyserState } from './types'

declare global {

  interface Window {

    webkitAudioContext: typeof AudioContext

  }

}

/** This class creates the audioData array and passes it to the AudioSpectrum, which displays the audio data */
class AudioAnalyser extends Component<AudioAnalyserProps, AudioAnalyserState> {

  private audioContext: AudioContext
  private source: MediaStreamAudioSourceNode
  private analyser: AnalyserNode
  private dataArray: Uint8Array
  private rafId: number
  private interval

  constructor (props) {

    super(props)
    this.state = { audioData: new Uint8Array(0) }
    this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
    this.analyser = this.audioContext.createAnalyser()
    this.dataArray = new Uint8Array(this.analyser.frequencyBinCount)
    this.source = this.audioContext.createMediaStreamSource(this.props.audio)
    this.source.connect(this.analyser)
    this.rafId = requestAnimationFrame(this.tick)

  }

  componentDidMount () {

    this.interval = setInterval(() => {

      this.setState({ audioData: this.dataArray })

    }, 100)

  }

  tick = () => {

    this.analyser.getByteFrequencyData(this.dataArray)
    this.rafId = requestAnimationFrame(this.tick)

  }

  componentWillUnmount () {

    cancelAnimationFrame(this.rafId)
    this.analyser.disconnect()
    this.source.disconnect()
    clearInterval(this.interval)

  }

  render () {

    return <AudioSpectrum
      audioData={this.state.audioData}
      {...this.props.spectrumProps}
    />

  }

}

export default AudioAnalyser
